import { render, staticRenderFns } from "./WelcomeToScan.vue?vue&type=template&id=522b7b4a&scoped=true&"
import script from "./WelcomeToScan.vue?vue&type=script&lang=js&"
export * from "./WelcomeToScan.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeToScan.vue?vue&type=style&index=0&id=522b7b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b7b4a",
  null
  
)

export default component.exports